import type {TSignUpParams} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import type {TFormError} from '@kapitalist/contract/types'
import type {EmptyObject} from '@kapitalist/utils/EmptyObject'
import {PostApi} from '~/api/client'

export type TSignUpResponse = EmptyObject

const endpoint = endpoints.auth.signup

export default class SignUp extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected mockRequestFailure(params: TSignUpParams): TFormError | null {
    if (params.password === 'failfailfail') {
      return {errors: {password: [`That password isn't right.`]}}
    }

    // return super.mockRequestFailure(params, pathPieces)
    return null // TODO replace this with defaultMockRequestFailure if/once we bring that behavior in from MW
  }

  protected getMockResponse(): EmptyObject {
    return {}
  }

  protected transformResponse(r: EmptyObject) {
    return r
  }
}
